import React, { FC } from 'react';
import { css } from "styled-components";
import TestIds from '../../../automated-tests-ids/ids';
import Container from 'saur-design-sys-web/lib/Atoms/Container/Container';

interface IProps {
    file: any;
    index: number;
    onClick: Function;
}

const FileItem: FC<IProps> = ({
    file,
    index,
    onClick
}) => {

    const isEvenIndex = index % 2 === 0;
    const rowColor = isEvenIndex ? 'dark' : 'light';


    return (
        <Container className={`file-item file-item-${rowColor}`} onClick={() => onClick(file)} automatedTestId={TestIds.sharePoint.fileItem.fileLine}>
            {file.label}
        </Container>
    );
};

export default FileItem;

export const FileItemStyles = css`
    .file-item{
        display: flex;
        align-items: flex-start;
        padding: 15px;
        cursor: pointer;
        background-color: #FFF;
        color: #000;
    }
    .file-item:hover {
        background-color: #1156B2;
        color: #FFFFFF;
    }
    .file-item-dark {
        background-color: #f3f4f7;
    }
`;